import React from "react";
import {
  Box,
  Button,
  Divider,
  Drawer,
  Paper,
  Step,
  StepConnector,
  StepLabel,
  Stepper,
  Typography,
} from "@mui/material";
import close from "../../../assets/svg/drawer_close.svg";
import ModeEditIcon from "@mui/icons-material/ModeEdit";
import BoxImage from "../../../assets/boximage.png";
import DataTableComponent from "../../../components/common/DataTable/DataTable";
import { generateItemColumns } from "../helper";
import SimpleBar from "simplebar-react";

const itemData = [
  {
    id: 1,
    image: "http://dummyimage.com/160x100.png/5fa2dd/ffffff",
    item_name: "Yezz 5E3",
    qty: 1,
    add_ons: 1,
    customslq: 1,
  },
  {
    id: 2,
    image: "http://dummyimage.com/140x100.png/5fa2dd/ffffff",
    item_name: "Gigabyte i300",
    qty: 2,
    add_ons: 2,
    customslq: 2,
  },
  {
    id: 3,
    image: "http://dummyimage.com/221x100.png/cc0000/ffffff",
    item_name: "alcatel 2",
    qty: 3,
    add_ons: 3,
    customslq: 3,
  },
  {
    id: 4,
    image: "http://dummyimage.com/178x100.png/5fa2dd/ffffff",
    item_name: "Micromax A99 Xpress",
    qty: 4,
    add_ons: 4,
    customslq: 4,
  },
  {
    id: 5,
    image: "http://dummyimage.com/197x100.png/dddddd/000000",
    item_name: "NEC N109",
    qty: 5,
    add_ons: 5,
    customslq: 5,
  },
];

const steps = [
  {
    label: (
      <Box sx={{ display: "flex", flexDirection: "column", gap: "4px" }}>
        <Typography>Pick Up</Typography>
        <Typography sx={{ color: "#959BA1" }}>12/11/2023</Typography>
      </Box>
    ),
  },
  {
    label: (
      <Box sx={{ display: "flex", flexDirection: "column", gap: "4px" }}>
        <Typography>Packing</Typography>
        <Typography sx={{ color: "#959BA1" }}>-</Typography>
      </Box>
    ),
  },
  {
    label: (
      <Box sx={{ display: "flex", flexDirection: "column", gap: "4px" }}>
        <Typography>Delivery</Typography>
        <Typography sx={{ color: "#959BA1" }}>-</Typography>
      </Box>
    ),
  },
  {
    label: (
      <Box sx={{ display: "flex", flexDirection: "column", gap: "4px" }}>
        <Typography>Done</Typography>
        <Typography sx={{ color: "#959BA1" }}>-</Typography>
      </Box>
    ),
  },
];

function SeeDetailsDrawer({ open, onClose }) {
  const storeColumns = generateItemColumns();

  const [activeStep, setActiveStep] = React.useState(0);

  return (
    <Drawer
      variant="temporary"
      anchor="right"
      open={open}
      onClose={onClose}
      BackdropProps={{ sx: { background: "rgba(0, 0, 0, 0.5)" } }}
    >
      <Box sx={{ width: { xs: "100%", sm: "600px" } }}>
        <Box
          sx={{
            borderBottom: "1px solid #E5E5E8",
            paddingLeft: "20px",
            paddingTop: "20px",
            paddingBottom: "20px",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography variant="h5" component="h5">
            Add User
          </Typography>
          <Box
            sx={{ paddingRight: "20px", cursor: "pointer" }}
            onClick={onClose}
          >
            <img src={close} alt="close" />
          </Box>
        </Box>
        <Box
          sx={{
            minHeight: "86vh",
            borderBottom: "1px solid rgba(229, 229, 232, 1)",
            paddingX: "10px",
          }}
        >
          <SimpleBar
            forceVisible="x"
            autoHide={true}
            style={{
              overflowX: "hidden",
              maxHeight: "86vh",
            }}
            className="custom-scrollbar"
          >
            <Box
              sx={{
                margin: "15px 10px",
              }}
            >
              <Stepper
                activeStep={activeStep}
                alternativeLabel
                sx={{
                  width: "100%",
                  margin: "0 auto",
                  paddingBottom: 5,
                }}
              >
                {steps.map((step) => (
                  <Step key={step.label}>
                    <StepLabel
                      StepIconProps={{
                        sx: {
                          "&.MuiStepIcon-root": {
                            color: "#FFF",
                            border: "1px solid",
                            borderRadius: "100%",
                            borderColor: "#959BA1",
                          },
                          "& .MuiStepIcon-text": {
                            fill: "#959BA1",
                            fontWeight: "bold",
                          },
                          "&.Mui-completed": {
                            color: "#38A34F",
                            borderColor: "#38A34F",
                          },
                          "&.Mui-active": {
                            color: "white",
                            border: "1px solid",
                            borderRadius: "100%",
                            borderColor: "#F68712",
                            "& .MuiStepIcon-text": {
                              fill: "#F68712",
                              color: "#FFF",
                              fontWeight: "bold",
                            },
                          },
                        },
                      }}
                    >
                      <span
                        style={{
                          fontSize: "16px",
                          fontWeight: "bold",
                          color: "black",
                        }}
                      >
                        {step.label}
                      </span>
                    </StepLabel>
                    {step.index > 0 && (
                      <StepConnector
                        sx={{
                          "& .MuiStepConnector-line": {
                            borderWidth: "1px",
                            borderColor:
                              step.index < activeStep ? "#38A34F" : "#EDEDED",
                          },
                        }}
                      />
                    )}
                  </Step>
                ))}
              </Stepper>
            </Box>
            <Divider />
            <Box
              sx={{
                border: "2px solid #E5E5E8",
                borderRadius: "4px",
                margin: "15px",
                marginLeft: "10px",
                padding: "12px",
                display: "flex",
                flexDirection: { xs: "column", sm: "row" },
                justifyContent: "space-between",
              }}
            >
              <Box>
                <Typography
                  variant="subtitle1"
                  sx={{
                    color: "rgba(149, 155, 161, 1)",
                    fontSize: "12px",
                    fontWeight: "500",
                  }}
                >
                  Order Number
                </Typography>
                <Typography
                  sx={{ fontSize: "16px", fontWeight: 600, marginTop: "8px" }}
                >
                  24-05000001
                </Typography>
              </Box>
              <Box>
                <Typography
                  variant="subtitle1"
                  sx={{
                    color: "rgba(149, 155, 161, 1)",
                    fontSize: "12px",
                    fontWeight: "500",
                  }}
                >
                  Value
                </Typography>
                <Typography
                  sx={{ fontSize: "16px", fontWeight: 600, marginTop: "8px" }}
                >
                  $565
                </Typography>
              </Box>
            </Box>

            <Box
              sx={{
                margin: "13px 10px",
                display: "flex",
                flexDirection: { xs: "column", sm: "row" },
                justifyContent: "space-between",
              }}
            >
              <Box>
                <Typography
                  variant="subtitle1"
                  sx={{
                    color: "#9BA1A7",
                    fontSize: "12px",
                    fontWeight: "500",
                  }}
                >
                  Customer Name
                </Typography>
                <Typography sx={{ fontSize: "16px", fontWeight: 700 }}>
                  Walmart
                </Typography>
              </Box>

              <Box>
                <Typography
                  variant="subtitle1"
                  sx={{
                    color: "#9BA1A7",
                    fontSize: "12px",
                    fontWeight: "500",
                  }}
                >
                  Shipping Method
                </Typography>
                <Typography sx={{ fontSize: "16px", fontWeight: 700 }}>
                  AYZ store
                </Typography>
              </Box>

              <Box>
                <Typography
                  variant="subtitle1"
                  sx={{
                    color: "#9BA1A7",
                    fontSize: "12px",
                    fontWeight: "500",
                  }}
                >
                  Curier
                </Typography>
                <Typography sx={{ fontSize: "16px", fontWeight: 700 }}>
                  -
                </Typography>
              </Box>
            </Box>

            <Box
              sx={{
                margin: "15px 10px",
                display: "flex",
                flexDirection: { xs: "column", sm: "row" },
                justifyContent: "space-between",
              }}
            >
              <Box>
                <Typography
                  variant="subtitle1"
                  sx={{
                    color: "#9BA1A7",
                    fontSize: "12px",
                    fontWeight: "500",
                  }}
                >
                  Delivery location
                </Typography>
                <Typography sx={{ fontSize: "16px", fontWeight: 700 }}>
                  John Doe, 5500 Morgan ave N, Lagos, Nigeria, Phone:
                  +234773388444 Email: test@gmail.com
                </Typography>
              </Box>

              {/* <Box>
                <Typography
                  variant="subtitle1"
                  sx={{
                    color: "#9BA1A7",
                    fontSize: "12px",
                    fontWeight: "500",
                  }}
                >
                  Dimention
                </Typography>
                <Typography sx={{ fontSize: "16px", fontWeight: 700 }}>
                  12*12*8
                </Typography>
              </Box>

              <Box>
                <Typography
                  variant="subtitle1"
                  sx={{
                    color: "#9BA1A7",
                    fontSize: "12px",
                    fontWeight: "500",
                    textAlign: { xs: "left", sm: "right" },
                  }}
                >
                  Sheif ID
                </Typography>
                <Typography sx={{ fontSize: "16px", fontWeight: 700 }}>
                  A1 - Level 1
                </Typography>
              </Box> */}
            </Box>

            <Box
              sx={{
                margin: "15px 10px",
              }}
            >
              <Button
                sx={{
                  border: "1px solid #E8E8EB",
                }}
              >
                <ModeEditIcon
                  sx={{
                    fontSize: "17.5px",
                    marginRight: "3px",
                  }}
                />{" "}
                Edit package details
              </Button>
            </Box>
            <Divider />
            <Box
              sx={{
                margin: "15px 10px",
              }}
            >
              <Typography sx={{ fontSize: "18px", fontWeight: 600 }}>
                Featured image
              </Typography>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: { xs: "column", sm: "row" },
                  gap: "10px",
                }}
              >
                <img
                  src={BoxImage}
                  alt="package_image"
                  width={130}
                  height={130}
                />
                <img
                  src={BoxImage}
                  alt="package_image"
                  width={130}
                  height={130}
                />
                <img
                  src={BoxImage}
                  alt="package_image"
                  width={130}
                  height={130}
                />
              </Box>
            </Box>
            <Divider />
            <Box
              sx={{
                margin: "15px 10px",
                width: "100%",
              }}
            >
              <Typography sx={{ fontSize: "18px", fontWeight: 600 }}>
                Item List
              </Typography>
              <Box>
                {itemData?.length > 0 && (
                  <Box sx={{ display: "contents" }}>
                    <Paper
                      sx={{
                        width: "100%",
                        border: "1px solid #E5E5E8",
                        borderRadius: "4px",
                      }}
                    >
                      <DataTableComponent
                        data={itemData || []}
                        columns={storeColumns}
                      />
                    </Paper>
                  </Box>
                )}
              </Box>
            </Box>
            <Divider />
          </SimpleBar>
        </Box>
        <Box
          sx={{
            paddingTop: "10px",
            paddingX: "20px",
            display: "flex",
            justifyContent: "flex-end",
            width: "100%",
          }}
        >
          <Button
            sx={{
              backgroundColor: "#481AA3",
              height: "42px",
              width: "189px",
              fontWeight: 600,
              borderRadius: "4px",
              color: "white",
              ":hover": {
                backgroundColor: "#481AA3",
              },
            }}
          >
            Packing Done
          </Button>
        </Box>
      </Box>
    </Drawer>
  );
}

export default SeeDetailsDrawer;
